export default __webpack_public_path__ + "static/media/symbol-defs.ed399770.svg";